import React from 'react';
import AuthWizardProvider from './AuthWizardProvider';

const WizardLayout = (props) => {
  return (
    <AuthWizardProvider initialUser={props.initialUser}>
      {props.children}
    </AuthWizardProvider>
  );
};

export default WizardLayout;
